import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/teacher-homeworks', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/teacher-homeworks/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/teacher-homeworks', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = ({ id, data }) => {
  return httpClient
    .put(`/api/teacher-homeworks/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changeStatus = (id, data) => {
  return httpClient
    .put(`/api/homeworks/change-status/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getSubject = (class_id, Options = {}) => {
  return httpClient
    .get(`/api/homeworks/queries/${class_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getClass = (Options = {}) => {
  return httpClient
    .get('/api/homeworks/queries', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getFile = (homework_id, Options = {}) => {
  return httpClient
    .get(`/api/homeworks/files/${homework_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const removeFile = (Options = {}) => {
  return httpClient
    .get('/api/homework-remove-files', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const sendNotification = id => {
  return httpClient
    .get(`/api/homework-send/notifications/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const academicYear = (Options = {}) => {
  return httpClient
    .get('/api/homeworks/queries/acYear', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProgramMain = (Options = {}) => {
  return httpClient
    .get('/api/homeworks/queries/program-main', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProgramSub = (Options = {}) => {
  return httpClient
    .get('/api/homeworks/queries/program-sub', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTeacher = (Options = {}) => {
  return httpClient
    .get('/api/homeworks/queries/teachers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  removeFile,
  getClass,
  getSubject,
  get,
  find,
  store,
  update,
  changeStatus,
  sendNotification,
  academicYear,
  getProgramMain,
  getProgramSub,
  getFile,
  getTeacher
}
